var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g, _g2, _path40, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 178,
    viewBox: "0 0 179 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4284 88.9999L20.0586 48.9495L89.4263 8.8999L158.796 48.9506L89.4284 88.9999Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6665 69.5076L53.8203 68.4417L123.188 28.3921L125.034 29.4576L55.6665 69.5076Z",
    fill: "#8A8A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.6159 72.3662L48.8672 65.583L118.234 25.5337L129.983 32.3169L60.6159 72.3662Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4288 169.1L20.0586 129.049V48.9502L89.4288 89.0005V169.1Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.6205 72.3745V80.7961L59.1349 81.5768L57.6721 79.094L56.1869 79.8747L54.7237 77.3916L53.2602 78.1852L51.7974 75.7024L50.3343 76.4959L48.8711 74.0125V65.5913L60.6205 72.3745Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.799 129.049L89.4297 169.1V89.0005L158.799 48.9502V129.049Z",
    fill: "#C6C6C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M153.343 69.0844L136.146 79.0129C135.349 79.4739 134.699 79.0987 134.699 78.177V69.6704C134.699 68.749 135.349 67.6241 136.146 67.1634L153.343 57.2353C154.141 56.7743 154.791 57.1495 154.791 58.0704V66.5774C154.791 67.4988 154.141 68.6237 153.343 69.0844ZM136.147 67.9961C135.746 68.2275 135.42 68.7914 135.42 69.2538V77.7605C135.42 78.2233 135.746 78.4112 136.147 78.1795L153.343 68.2513C153.744 68.0203 154.07 67.456 154.07 66.9939V58.487C154.07 58.0245 153.744 57.8366 153.343 58.068L136.147 67.9961Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.472 76.3464L136.562 76.8719V68.8238L137.472 68.2983V76.3464Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.624 69.9073L147.715 70.4321V62.3843L148.624 61.8589V69.9073Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.244 75.3253L137.93 76.0843V68.0362L139.244 67.2769V75.3253Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.31 70.6667L145.996 71.4257V63.3776L147.31 62.6187V70.6667Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.824 68.0619L150.914 68.5874V60.5396L151.824 60.0142V68.0619Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150.506 68.8217L149.191 69.581V61.5326L150.506 60.7739V68.8217Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144.351 72.3763L142.379 73.5152V65.4671L144.351 64.3286V72.3763Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.505 74.5951L139.848 74.975V66.9265L140.505 66.5474V74.5951Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.927 67.4241L152.27 67.8036V59.7558L152.927 59.376V67.4241Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M141.771 73.8653L141.113 74.2448V66.1964L141.771 65.8169V73.8653Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.572 71.671L144.914 72.0501V64.0024L145.572 63.6226V71.671Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9562 153.736C99.9281 153.425 99.6856 153.309 99.3944 153.477C99.2154 153.58 99.0559 153.768 98.9523 153.978C98.89 154.104 98.7689 154.174 98.7066 154.119C98.6034 154.029 98.4439 154.025 98.2652 154.129C98.0861 154.232 97.9266 154.42 97.823 154.63C97.7607 154.756 97.6397 154.826 97.5781 154.771C97.4745 154.681 97.3154 154.677 97.1363 154.781C96.9572 154.884 96.7978 155.072 96.6945 155.282C96.6319 155.408 96.5112 155.477 96.4492 155.424C96.3456 155.333 96.1865 155.33 96.0074 155.433C95.7159 155.601 95.4741 155.997 95.4453 156.34C95.4763 154.915 96.4742 153.207 97.7009 152.499C98.9277 151.791 99.9256 152.346 99.9562 153.736Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2631 157.995C97.8099 158.256 97.4414 158.044 97.4414 157.52V153.952L97.9569 153.654V157.223C97.9569 157.417 98.0943 157.497 98.2631 157.399C98.4314 157.302 98.5689 157.064 98.5689 156.869L99.0847 156.572C99.0847 157.095 98.7159 157.733 98.2631 157.995Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.202 157.99L95.1981 160.879C94.6559 161.192 94.2148 160.937 94.2148 160.311V154.533C94.2148 153.907 94.6559 153.143 95.1981 152.83L100.202 149.941C100.744 149.628 101.185 149.882 101.185 150.509V156.287C101.185 156.912 100.744 157.676 100.202 157.99ZM95.1981 153.396C94.9258 153.552 94.7047 153.936 94.7047 154.25V160.028C94.7047 160.342 94.9258 160.47 95.1981 160.313L100.202 157.424C100.474 157.267 100.695 156.884 100.695 156.57V150.792C100.695 150.477 100.474 150.35 100.202 150.507L95.1981 153.396Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.721 149.056C105.649 149.02 105.533 149.09 105.463 149.21L104.997 150.016L104.27 149.593C104.938 148.529 105.657 149.01 105.721 149.056Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.914 148.06L106.185 149.323L105.726 149.058C105.726 149.058 105.723 149.057 105.721 149.056C105.657 149.009 104.938 148.529 104.27 149.593L104.734 148.789C105.208 147.968 105.982 147.521 106.456 147.795L106.914 148.06Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M107.258 149.011L105.809 149.848L107.258 147.337V149.011Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.105 152.249C104.082 152.373 104.143 152.452 104.238 152.427L104.873 152.259L104.605 153.562C103.762 153.72 104.075 152.373 104.105 152.249Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.279 151.686L104.276 151.419L104.108 152.24C104.108 152.24 104.107 152.244 104.106 152.249C104.076 152.373 103.764 153.72 104.607 153.562L103.973 153.732C103.325 153.906 102.939 153.356 103.112 152.508L103.279 151.686Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.97 150.369L104.695 151.4L102.715 151.931L103.97 150.369Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.61 151.287C106.705 151.199 106.76 151.049 106.735 150.954L106.566 150.317L107.562 149.437C107.737 150.343 106.705 151.209 106.61 151.287Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.244 152.845L105.977 151.849L106.604 151.293C106.604 151.293 106.607 151.29 106.61 151.287C106.705 151.209 107.737 150.343 107.562 149.437L107.732 150.071C107.906 150.719 107.519 151.715 106.87 152.29L106.244 152.845Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.211 153.212L105.936 151.343L106.467 153.324L105.211 153.212Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M107.745 153.636L102.741 156.525C102.199 156.838 101.758 156.583 101.758 155.957V150.179C101.758 149.553 102.199 148.789 102.741 148.476L107.745 145.587C108.287 145.274 108.728 145.529 108.728 146.155V151.932C108.728 152.559 108.287 153.323 107.745 153.636ZM102.741 149.042C102.469 149.199 102.248 149.582 102.248 149.896V155.675C102.248 155.989 102.469 156.116 102.741 155.959L107.745 153.07C108.017 152.914 108.238 152.53 108.238 152.216V146.438C108.238 146.124 108.017 145.996 107.745 146.153L102.741 149.042Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M111.744 149.348L111.02 149.766V146.032L111.744 145.613V149.348Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M114.931 147.507V148.344L110.43 150.943V150.106L114.931 147.507Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.345 147.848L113.621 148.266V144.532L114.345 144.113V147.848Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M112.57 145.316L110.195 146.687L111.383 144.631L112.57 145.316Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M115.168 143.817L112.793 145.187L113.98 143.131L115.168 143.817Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M115.183 149.342L110.179 152.231C109.637 152.544 109.195 152.289 109.195 151.663V145.885C109.195 145.26 109.637 144.495 110.179 144.182L115.183 141.293C115.725 140.98 116.165 141.235 116.165 141.861V147.639C116.165 148.265 115.725 149.029 115.183 149.342ZM110.179 144.748C109.906 144.905 109.686 145.288 109.686 145.602V151.38C109.686 151.694 109.907 151.822 110.179 151.665L115.183 148.776C115.455 148.62 115.676 148.236 115.676 147.922V142.144C115.676 141.83 115.455 141.702 115.183 141.859L110.179 144.748Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M120.307 142.391C121.286 141.654 122.05 139.758 122.05 138.601L118.184 140.833C118.184 141.991 118.948 143.006 119.926 142.612V144.951L118.919 145.533V145.91L121.315 144.527V144.15L120.307 144.731V142.391H120.307Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M122.62 145.047L117.616 147.936C117.074 148.249 116.633 147.995 116.633 147.369V141.591C116.633 140.965 117.074 140.201 117.616 139.888L122.62 136.998C123.162 136.686 123.603 136.94 123.603 137.566V143.344C123.603 143.97 123.162 144.734 122.62 145.047ZM117.616 140.454C117.344 140.611 117.123 140.994 117.123 141.308V147.086C117.123 147.4 117.344 147.528 117.616 147.371L122.62 144.481C122.892 144.325 123.113 143.941 123.113 143.627V137.849C123.113 137.535 122.892 137.407 122.62 137.564L117.616 140.454Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2227 60.0142L90.0691 87.8922H88.7896L139.244 60.2402L90.0694 90.109L89.4297 90.4977L88.7889 90.109L39.2227 60.0142Z",
    fill: "#C6C6C6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5131_565384)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5131_565384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.965 94.6236C45.9389 93.6131 47.3636 92.2383 49.2817 90.7227C53.2199 98.8806 57.1921 107.03 60.2031 115.565C60.2627 115.726 62.6911 120.572 62.8612 126.866C62.9207 129.131 62.6698 130.783 61.5811 132.216C59.7396 134.639 56.6179 134.962 56.0608 135.02C53.7217 135.26 51.8972 134.548 50.2131 133.707C45.1053 131.164 41.4266 127.23 38.8961 122.216C37.8456 120.128 36.7101 118.099 36.0977 115.826C35.2599 112.703 35.1408 109.709 36.0552 106.877C36.5485 105.353 37.2545 104.301 38.3347 102.632C39.4873 100.856 40.6058 99.5514 42.2814 97.5968C43.1618 96.5699 43.906 95.7209 44.965 94.6194V94.6236Z",
    fill: "#6691E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6882 133.338C61.4623 131.661 62.4574 128.941 62.5127 125.528C62.5425 123.553 62.2575 121.454 60.6882 116.795C58.9275 111.561 57.1115 107.738 56.4566 106.355C54.7767 102.806 52.3185 97.5347 49.2734 90.7227C51.1107 89.998 52.9479 89.2774 54.7852 88.5527C60.4118 100.843 64.5031 110.177 66.2935 114.414C66.621 115.188 67.2887 117.275 67.8714 120.062C68.3179 122.211 68.5178 124.659 67.5482 127.123C65.9916 131.094 61.9598 132.846 60.6797 133.338H60.6882Z",
    fill: "#336CD6"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1103 48.9939L89.4771 8.94482L118.287 25.5786L123.239 28.4372L123.353 28.503L125.085 29.5028L158.846 48.9951L158.849 48.9934V129.092L89.48 169.143V90.5413L89.4796 90.5415V169.143L20.1094 129.092V48.9945V48.9934L20.1103 48.9939Z",
    fill: "#CBDAF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5131_565384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5126,
    height: 46.5126,
    fill: "white",
    transform: "translate(29.9453 88.5527)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5131_565384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8324,
    height: 46.5126,
    fill: "white",
    transform: "translate(35.418 88.5527)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.0aa555dee45701ddc47b6c973ffe0a9c.svg";
export { ForwardRef as ReactComponent };